import { useEffect, useRef, useState } from 'react';
import ellipsisIcon from '../../../../assets/images/3-dots.png';
import styles from './index.module.scss';
import ActionsModal from '../ActionsModal';

interface VolumeListTabelProps {
    itemName: string;
    columns: {
        key: string;
        label: string;
    }[];
    filteredItems: any[];
    navigateToItemPage: (item: any) => void;
    handleDeleteItem: (itemId: string) => void;
    handleUpdateItemStatus: (itemId: string, status: string) => void;
}

const ListTabel = ({ itemName, columns, filteredItems, navigateToItemPage, handleDeleteItem, handleUpdateItemStatus }: VolumeListTabelProps) => {
    const [openItemId, setOpenItemId] = useState<string | null>(null);
    const tableRef = useRef<HTMLTableElement>(null);

    const toggleActionsModal = (e: React.MouseEvent, itemId: string) => {
        e.stopPropagation();
        setOpenItemId(openItemId === itemId ? null : itemId);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (tableRef.current && !tableRef.current.contains(event.target as Node)) {
                setOpenItemId(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={styles.tableWrapper}>
            <table className={styles.table} ref={tableRef}>
                <thead className={styles.thead}>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.key} className={styles.th}>{column.label}</th>
                        ))}
                        <th className={styles.th}></th>
                    </tr>
                </thead>
                <tbody className={styles.tbody}>
                    {filteredItems.length > 0 ? (
                        filteredItems.map((item) => (
                            <tr key={item._id} className={styles.tr} onClick={() => navigateToItemPage(item)}>
                                {columns.map((column) => (
                                    <td key={column.key} className={styles.td} data-label={column.label}>
                                        {item[column.key]}
                                    </td>
                                ))}
                                <td className={styles.td}>
                                    <div className={styles.ellipsis} onClick={(e) => toggleActionsModal(e, item._id)}>
                                        <img src={ellipsisIcon} alt="Actions" />
                                    </div>
                                    {openItemId === item._id &&
                                        (<ActionsModal
                                            item={item}
                                            hasDelete={handleDeleteItem !== undefined}
                                            navigateToItemPage={navigateToItemPage}
                                            deleteItem={handleDeleteItem}
                                            updateStatus={handleUpdateItemStatus}
                                        />)}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={columns.length + 1} className={styles.noResults}>
                                No {itemName} found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ListTabel;